import { QuizQuestion } from "../models/quiz/QuizQuestionModel";
import { QuizCategory } from "../models/quiz/QuizCategoryModel";

const pronounQuestions: QuizQuestion[] = [
    {
        category: QuizCategory.PRONOUNS,
        questionText: "¿Cuál es el pronombre de objeto directo correcto? (Ella)'___ vi ayer en el cine.'",
        options: ["Te", "Lo", "Le", "Nos"],
        correctAnswerIndex: 1,
        explanation: "El pronombre de objeto directo para 'ella' es 'lo'."
    },
    {
        category: QuizCategory.PRONOUNS,
        questionText: "¿Cuál es el pronombre reflexivo correcto? 'Ellos ___ fueron al centro comercial.'",
        options: ["se", "nos", "me", "te"],
        correctAnswerIndex: 0,
        explanation: "Para expresar una acción reflexiva, se usa el pronombre 'se' en este contexto."
    },
    {
        category: QuizCategory.PRONOUNS,
        questionText: "¿Cuál es el pronombre de objeto directo correcto? '___ llamaron a la puerta a las tres.'",
        options: ["Nos", "Te", "Lo", "La"],
        correctAnswerIndex: 3,
        explanation: "El pronombre de objeto directo para 'la puerta' es 'la'."
    },
    {
        category: QuizCategory.PRONOUNS,
        questionText: "¿Cuál es el pronombre de objeto indirecto correcto? '___ dije la noticia a Marta.'",
        options: ["Le", "Te", "Les", "Nos"],
        correctAnswerIndex: 0,
        explanation: "'Le' es el pronombre de objeto indirecto correcto para 'Marta'."
    },
    {
        category: QuizCategory.PRONOUNS,
        questionText: "¿Cuál es el pronombre de objeto indirecto correcto? '___ di las llaves a ellos ayer.'",
        options: ["Nos", "Les", "Te", "Le"],
        correctAnswerIndex: 1,
        explanation: "'Les' es el pronombre de objeto indirecto para 'ellos' en plural."
    },
    {
        category: QuizCategory.PRONOUNS,
        questionText: "¿Cuál es el pronombre de objeto indirecto correcto? '___ compraron un regalo para ti.'",
        options: ["Te", "Nos", "Le", "Me"],
        correctAnswerIndex: 0,
        explanation: "'Te' es el pronombre de objeto indirecto que corresponde a la segunda persona singular (tú)."
    }
];

export default pronounQuestions;


